export default __webpack_public_path__ + "static/media/whiteboard.b5d264f6.svg";